// import React, { useState } from 'react';

// const UserModal = ({ isOpen, onClose, onSubmit }) => {
//   const [formData, setFormData] = useState('');

//   const handleInputChange = (e) => {
//     setFormData(e.target.value);
//   };

//   const handleSubmit = () => {
//     onSubmit(formData);
//     onClose();
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-900 bg-opacity-50">
//       <div className="bg-white p-4 rounded shadow-lg">
//         <h2 className="text-xl mb-4">Modal Title</h2>
//         <input
//           type="text"
//           value={formData}
//           onChange={handleInputChange}
//           className="border rounded p-2 w-full"
//         />
//         <div className="flex justify-end mt-4">
//           <button onClick={onClose} className="mr-2 p-2 bg-gray-300 rounded">Close</button>
//           <button onClick={handleSubmit} className="p-2 bg-blue-500 text-white rounded">Submit</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserModal;
import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';

const UserModal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div className="bg-white p-3 rounded shadow-md w-1/4">
                <div className='flex justify-end mb-2'>
                    <button onClick={onClose} className="">
                        <XMarkIcon className="w-6 h-6" />
                    </button>
                </div>

                {children}
            </div>
        </div>
    );
};

export default UserModal;
